import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * `<lever>` — single-axis throw lever primitive.
 *
 * Covers T-bar style transition levers and similar short-throw single-axis
 * mechanisms. Differs from `<fader>` in throw length, return behaviour and
 * the visual character of the handle.
 */
@customElement('panel-lever')
export class LeverElement extends LitElement {
  static override styles = [
    css`
      :host {
        display: inline-block;
        contain: layout paint;
        block-size: 100%;
        inline-size: 100%;
      }
    `,
  ];

  /** Whether the lever springs back to centre when released. */
  @property({ type: Boolean, reflect: true }) accessor springReturn = false;

  /** Whether the lever has a centre detent. */
  @property({ type: Boolean, reflect: true }) accessor centreDetent = false;

  override render() {
    // TODO(Phase 2): SVG handle geometry, pointer-driven throw tracking,
    // spring-return animation via Web Animations API timed against the
    // vendor's --motion-spring-return-ms token.
    return html`<svg viewBox="0 0 40 200" aria-label="lever"></svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'panel-lever': LeverElement;
  }
}
